import { JbCart } from '@jbhi-fi/apis/src/shopify/types/JbCart';
import { searchAlgoliaIndex } from '../algolia';
import { AlgoliaProductHit, BasketApiResponse, BasketApiLineItem } from '../types';

export const enrichBasketApiResponseWithAlgoliaData = async (
  basketResponse: BasketApiResponse
): Promise<BasketApiResponse> => {
  const filterSkus = generateSkuFilters(basketResponse.LineItems);
  const algoliaResponse = await fetchAlgoliaResults(filterSkus);
  return addAlgoliaDataToOfferings(basketResponse, algoliaResponse);
};

export const generateSkuFilters = (LineItems: Array<BasketApiLineItem>): string => {
  return LineItems.reduce((lineItemAcc, lineItem) => {
    if (!lineItem.Services) return lineItemAcc;
    return [
      ...lineItemAcc,
      ...lineItem.Services?.reduce((serviceAcc, service) => {
        return [...serviceAcc, ...service.Offerings.map(offering => `sku:${offering.Sku}`)];
      }, []),
    ];
  }, []).join(' OR ');
};

export const fetchAlgoliaResults = async (skuFilters: string): Promise<Array<AlgoliaProductHit>> => {
  try {
    const result = await searchAlgoliaIndex({
      filters: skuFilters,
    });
    return result?.hits as Array<AlgoliaProductHit>;
  } catch (e) {
    console.error('Error fetching algolia product data');
  }
  return [];
};

export const addAlgoliaDataToOfferings = (
  basketResponse: BasketApiResponse,
  algoliaData: Array<AlgoliaProductHit>
): BasketApiResponse => {
  const updatedLineItems = basketResponse.LineItems?.map(lineItem => {
    return {
      ...lineItem,
      Services: lineItem.Services?.map(service => {
        return {
          ...service,
          Offerings: service.Offerings?.map(offering => {
            return {
              ...offering,
              AlgoliaData: algoliaData.find(algoliaData => algoliaData.sku === offering.Sku),
            };
          }),
        };
      }),
    };
  });

  return {
    ...basketResponse,
    LineItems: updatedLineItems,
  };
};

export const shouldEnrichBasketApiResponse = (cart: JbCart) => {
  return Boolean(cart?.items?.length);
};
